import React from 'react';
import { Box, Typography } from '@mui/material';
import { Polygon, Popup } from 'react-leaflet';
import { colors } from '../../../styles/colors';

interface ProjectAreaLayerProps {
  projectName: string;
  flaecheCoordinates: [number, number][];
}

/**
 * Rendert die Windpark-Fläche als Polygon
 */
const ProjectAreaLayer: React.FC<ProjectAreaLayerProps> = ({
  projectName,
  flaecheCoordinates
}) => {
  if (flaecheCoordinates.length === 0) return null;

  return (
    <Polygon
      positions={flaecheCoordinates}
      pathOptions={{
        color: colors.map.projectArea,
        weight: 2,
        opacity: 1.0,
        fillOpacity: 0,
        fill: false // Deaktiviert die klickbare Füllung komplett
      }}
      pane="markerPane" // Über Flurstücken anzeigen
    >
      <Popup>
        <Box>
          <Typography variant="subtitle2" sx={{
            fontWeight: "bold"
          }}>
            {projectName}
          </Typography>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Windpark-Fläche
          </Typography>
        </Box>
      </Popup>
    </Polygon>
  );
};

export default ProjectAreaLayer;
